export const labelPositions = (hasPrice = false, pos, imgWidth = 0) => {
  const positions = {
    0: { left: '40px', top: !hasPrice ? 0 : 0 },
    1: { right: `${50 - imgWidth / 2}%`, top: 0 },
    2: { right: '40px', top: 0 },
    3: { left: '40px', top: `${50 - imgWidth / 2}%` },
    4: { right: `${50 - imgWidth / 2}%`, top: `${50 - imgWidth / 2}%` },
    5: { right: '40px', top: `${50 - imgWidth / 2}%` },
    6: { left: '40px', top: `${100 - imgWidth}%` },
    7: { right: `${50 - imgWidth / 2}%`, top: `${100 - imgWidth}%` },
    8: { right: '40px', top: `${100 - imgWidth}%` },
  };

  return positions?.[pos];
};

export const modifyCss = (cssString) => {
  const style = {};

  cssString.split(';').forEach((rule) => {
    const [property, value] = rule.split(':').map((item) => item.trim());
    if (property && value) {
      const reactProperty = property
        .replace(/-([a-z])/g, (g) => g[1].toUpperCase())
        .replace('!important', '');

      style[reactProperty] = value.replace('!important', '').trim();
    }
  });

  return style;
};
